var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgGrid = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.3 120.6",
    style: {
      enableBackground: "new 0 0 115.3 120.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.grid{fill:current;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "grid",
    d: "M72.1,51.8V12.5c0-2.3-1.9-4.3-4.2-4.3c0,0,0,0,0,0H46.6c-2.3,0-4.2,1.9-4.2,4.2v39.3c0,2.3,1.9,4.2,4.2,4.2 h21.2C70.2,56,72.1,54.1,72.1,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "grid",
    d: "M108.2,51.8V12.5c0-2.3-1.9-4.2-4.2-4.2H82.7c-2.3,0-4.2,1.9-4.2,4.2v39.3c0,2.3,1.9,4.3,4.2,4.3 c0,0,0,0,0.1,0H104C106.3,56,108.2,54.1,108.2,51.8C108.2,51.8,108.2,51.8,108.2,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "grid",
    d: "M78.4,62.4h-68c-2.3,0-4.3,1.9-4.3,4.2V106c0,2.3,1.9,4.2,4.3,4.2H104c2.3,0,4.2-1.9,4.2-4.2V66.7 c0-2.3-1.9-4.2-4.2-4.2H78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "grid",
    d: "M36,51.8V12.5c0-2.3-1.9-4.2-4.2-4.2H10.4c-2.3,0-4.3,1.9-4.3,4.2v39.3c0,2.3,1.9,4.3,4.2,4.3c0,0,0,0,0.1,0 h21.2c2.3,0,4.3-1.9,4.3-4.2C36,51.8,36,51.8,36,51.8z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGrid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grid.4b9029c2.svg";
export { ForwardRef as ReactComponent };